export type ArtStatus = "available" | "sold" | "nfs" | "published";

export interface Artwork {
  id: string;
  title: string;
  year?: string;
  medium?: string;
  dimensions?: string;
  galleryAttribution?: string;
  description?: string;
  collectionId?: string | null;
  status: ArtStatus;
  price?: string;
  featured?: boolean;
  /** Key into the bundled seed images (used for the starter pieces). */
  seedKey?: string;
  /** Data URL for pieces uploaded through the admin. */
  image?: string;
  /** Legacy GridFS image reference used by older database records. */
  imageId?: string;
  createdAt: number;
}

export interface Collection {
  id: string;
  name: string;
  description?: string;
  coverArtId?: string | null;
  createdAt: number;
}

export interface GalleryState {
  artworks: Artwork[];
  collections: Collection[];
}

export interface User {
  username: string;
  name: string;
}

export const STATUS_LABEL: Record<ArtStatus, string> = {
  available: "Available",
  sold: "Sold",
  nfs: "Not for sale",
  published: "Published",
};
